import React from 'react';
import PropTypes from 'prop-types';
import AutoScopeStylesDecorator from '../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import applyDecoratorsDoNotUseInNewCode from '../../../Common/Utilities/Decorators/ApplyDecorators';

class ECargoLogoAndBlurbView extends React.PureComponent {
    static propTypes = {
        children: PropTypes.object
    }

    render() {
        return (
            <div className="background">
                <div className="displayBox">
                    <a href="/Info">
                        <div className="banner" />
                    </a>
                    <div className="user entry">
                        { this.props.children }
                    </div>
                </div>
            </div>
        );
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStylesDecorator);

export default withDecorators(ECargoLogoAndBlurbView);
